/** @jsxImportSource @emotion/react */

import { useTheme } from "@emotion/react";
import { Theme } from "@emotion/react";
import { CSSProperties } from "@emotion/serialize";
import { ReactElement, ReactNode } from "react";

export type TypographyProps = {
  children?: string | number | ReactElement | ReactNode | any;
  variant: keyof Theme["typography"];
  color?: keyof Theme["colors"];
  style?: CSSProperties;
  hoverStyle?: CSSProperties;
  focusedStyle?: CSSProperties;
  activeStyle?: CSSProperties;
  className?: string;
} & Pick<
  CSSProperties,
  | "width"
  | "height"
  | "minWidth"
  | "minHeight"
  | "maxWidth"
  | "maxHeight"
  | "textAlign"
  | "fontFamily"
  | "fontSize"
  | "lineHeight"
  | "fontWeight"
  | "fontStyle"
  | "margin"
  | "marginTop"
  | "marginBottom"
  | "marginLeft"
  | "marginRight"
>;

export default function Typography({
  children,
  variant,
  color = "black",
  style,
  hoverStyle,
  focusedStyle,
  activeStyle,
  className,
  ...cssOverwrites
}: TypographyProps) {
  const theme = useTheme();

  const textColor = theme.colors[color];

  return (
    <>
      <p
        className={className}
        css={{          
          margin: 0,
          color: textColor,
          ...theme.typography[variant],
          ...cssOverwrites,
          ...style,
          "&:hover": {
            ...hoverStyle,
          },
          "&:focused": {
            ...focusedStyle,
          },
          "&:active": {
            ...activeStyle,
          },
        }}
      >
        {children}
      </p>
    </>
  );
}
